import React from "react";

interface ResultsProps {
    isValid: boolean;
    resultText: string;
}

const Results = ({isValid, resultText}: ResultsProps) => {
    return (
        <div className={`mt-4 rounded-lg border px-4 py-3 text-sm font-mono ${
            isValid
                ? 'bg-success-bg border-success-border text-success-text'
                : 'bg-error-bg border-error-border text-error-text'
        }`}>
            <div className="flex items-start gap-2">
                <span className="mt-0.5 flex-shrink-0">{isValid ? '\u2713' : '\u2715'}</span>
                <pre className="whitespace-pre-wrap break-words">{resultText}</pre>
            </div>
        </div>
    );
}

export default Results
